import { customValidators } from "src/app/_helpers/customValidators";
import { Component, ElementRef, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertController, ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { HeaderModel } from "src/app/_component/header/header.model";
import { SelectColumns } from "src/app/_models/select.model";
import { globalHelper } from "src/app/_helpers/global";
import { ThisPlatform } from "src/app/_services/platform.service";
import { SpaceType } from "src/app/_types/space-type";
import { Equipment } from "../equipment.model";
import { EquipmentService } from "../equipment.service";

@Component({
  selector: "app-edit-equipment",
  templateUrl: "./edit-equipment.component.html",
  styleUrls: ["./edit-equipment.component.scss"],
})
export class EditEquipmentComponent implements OnInit {
  constructor(
    public equipmentServ: EquipmentService,
    private route: ActivatedRoute,
    private router: Router,
    public p: ThisPlatform,
    private alertController: AlertController,
    private translateService: TranslateService,
    private modalCtrl: ModalController,
    private el: ElementRef,
  ) {}

  form: FormGroup;
  fileData: File = null;
  validationError = false;
  spaceType: SpaceType;
  idEquipment = 0;
  loading = true;
  disableSaveButton = false;

  headerInit: HeaderModel = {
    title: "",
    showRightButtonsOnlyOnMobile: true,
    rightButtons: [
      {
        iconName: "trash",
        rolePermission: ["equipment.edit"],
        onClick: () => this.delete(),
      },
      {
        name: this.translateService.instant("SAVE"),
        fill: "outline",
        class: "primary-color outline-button",
        rolePermission: ["equipment.edit"],
        onClick: () => this.onSave(),
      },
    ],
  };

  selectColumns: SelectColumns[] = [
    {
      displayName: "NAME",
      name: "name",
      size: 5,
    },
    {
      displayName: "BUILDING.DESCRIPTION",
      name: "description",
      size: 7,
    },
  ];

  ngOnInit() {
    this.initForm();

    this.equipmentServ.filterIcons(this.spaceType);

    if (this.idEquipment === 0) {
      // new
      this.equipmentServ.equipment = new Equipment();

      this.headerInit.title = "equipment.add";
      (this.headerInit.rightButtons = [
        {
          name: this.translateService.instant("SAVE"),
          fill: "outline",
          class: "primary-color outline-button",
          rolePermission: ["building.edit"],
          onClick: () => this.onSave(),
        },
      ]),
        (this.loading = false);
    } else {
      this.equipmentServ
        .getEquipment(this.idEquipment)
        .subscribe((res: Equipment) => {
          this.equipmentServ.equipment = res;
          this.initFormData();
        });

      this.headerInit.title = "equipment.edit";
      (this.headerInit.rightButtons = [
        {
          iconName: "trash",
          rolePermission: ["equipment.edit"],
          onClick: () => this.delete(),
        },
        {
          name: this.translateService.instant("SAVE"),
          fill: "outline",
          class: "primary-color outline-button",
          rolePermission: ["equipment.edit"],
          onClick: () => this.onSave(),
        },
      ]),
        (this.loading = false);
    }
  }

  async delete() {
    let confirm = await globalHelper.Alert(
      this.alertController,
      this.translateService
    );
    if (confirm) {
      this.equipmentServ.deleteEquipment(this.idEquipment).subscribe(() => {
        this.refreshAndBack();
      });
    }
  }

  initFormData() {
    this.form.patchValue({
      name: this.equipmentServ.equipment.name,
      type: this.equipmentServ.equipment.type,
      iconName: this.currentIcon(this.equipmentServ.equipment.iconName),
    });
  }

  currentIcon(iconName) {
    if (iconName == "null") {
      return;
    }

    const currentIcon = this.equipmentServ.iconsList.filter(
      (icon) => icon.iconName === iconName
    );
    return currentIcon[0];
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl(null, {
        updateOn: "blur",
        validators: [Validators.required, customValidators.trimValidator()],
      }),
      type: new FormControl(this.spaceType, {
        updateOn: "blur",
        validators: [Validators.required],
      }),
      iconName: new FormControl(null, {
        updateOn: "blur",
      }),
    });
  }

  refreshAndBack() {
    this.equipmentServ.equipment = new Equipment();
    this.modalCtrl.dismiss();
  }

  onSave() {
    this.disableSaveButton = true;
    globalHelper.scrollToFirstInvalidControl(this.el);
    if (!this.form.valid) {
      this.disableSaveButton = false;
      this.validationError = true;
      return;
    }

    const { type, name, iconName } = this.form.value;

    this.equipmentServ.equipment = {
      id: this.idEquipment,
      type: type,
      name: name,
      iconName: iconName ? iconName.iconName : "null",
    };

    if (this.idEquipment === 0) {
      this.equipmentServ
        .createEquipment(this.equipmentServ.equipment)
        .subscribe({
          next: async () => { this.refreshAndBack(); },
          error: () => { this.disableSaveButton = false; },
          complete: () => { this.disableSaveButton = false; },
        });
    } else {
      this.equipmentServ.updateEquipment().subscribe({
        next: async () => { this.refreshAndBack(); },
        error: () => { this.disableSaveButton = false; },
        complete: () => { this.disableSaveButton = false; },
      });
    }
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
